import { noop } from '@kofno/piper';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Link } from '../../../../../../../Resource/Types';
import { T } from '../../../../../../../Translations';
import ToggleButton from '../../../../../../ToggleButton';
import PublishingStore from './Store';
import { isPublished } from './Store/Types';

export interface Props {
  publishLink: Maybe<Link>;
  publishedAt: Maybe<Date>;
  publishingStore: PublishingStore;
}

const Published: React.FC<Props> = ({ publishLink, publishedAt, publishingStore }) => {
  const published = isPublished(publishedAt);

  return (
    <div className="mt-10 flex">
      <p className="mr-2 font-semibold">
        <T kind="Published" />
      </p>
      {publishLink
        .map(() => (
          <ToggleButton
            cursorClassName="cursor-pointer"
            handleOnClick={publishingStore.publishing}
            value={published}
            intercomTarget="builder-publish-toggle-button"
            ariaLabel="Toggle publish collection"
          />
        ))
        .getOrElse(() => (
          <ToggleButton
            cursorClassName="cursor-not-allowed"
            handleOnClick={noop}
            value={published}
            intercomTarget="builder-publish-toggle-button-disabled"
            ariaLabel="Toggle publish collection (disabled)"
          />
        ))}
    </div>
  );
};

export default observer(Published);
